import { render, staticRenderFns } from "./warehouseAndLocation.vue?vue&type=template&id=960a140e&scoped=true"
import script from "./warehouseAndLocation.vue?vue&type=script&lang=js"
export * from "./warehouseAndLocation.vue?vue&type=script&lang=js"
import style0 from "./warehouseAndLocation.vue?vue&type=style&index=0&id=960a140e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960a140e",
  null
  
)

export default component.exports